// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d0ZA9{min-height:calc(100vh - var(--wpp-os-header-height));display:flex;justify-content:center}.puTPs{min-width:100%}`, "",{"version":3,"sources":["webpack://./src/app/App.module.scss"],"names":[],"mappings":"AAAA,OACE,oDAAA,CACA,YAAA,CACA,sBAAA,CAGF,OACE,cAAA","sourcesContent":[".container {\n  min-height: calc(100vh - var(--wpp-os-header-height));\n  display: flex;\n  justify-content: center;\n}\n\n.pageContent {\n  min-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `d0ZA9`,
	"pageContent": `puTPs`
};
export default ___CSS_LOADER_EXPORT___;
